var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"emoji",staticStyle:{"width":"1.5em","height":"1.5em","vertical-align":"middle"},attrs:{"draggable":"false","alt":_vm.alt,"src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }